import { render, staticRenderFns } from "./TransferAssets.vue?vue&type=template&id=c10a7e26&scoped=true"
import script from "./TransferAssets.vue?vue&type=script&lang=js"
export * from "./TransferAssets.vue?vue&type=script&lang=js"
import style0 from "./TransferAssets.vue?vue&type=style&index=0&id=c10a7e26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c10a7e26",
  null
  
)

export default component.exports